import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import preferences from 'Preferences';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal, {ModalButton} from 'ui-library/modals/Modal';

import {TENANT_SCHEDULED_MODAL_LAST_DISMISSED_PREFIX, TenantScheduledModal} from './ScheduledModalConstants';

function dismissModal(): void {
  preferences.set(
    `${TENANT_SCHEDULED_MODAL_LAST_DISMISSED_PREFIX}${TenantScheduledModal.GENENTECH_PTD_TRAINING_MODAL_KEY}`,
    new Date().toISOString()
  );
  ModalContainer.close(TenantScheduledModal.GENENTECH_PTD_TRAINING_MODAL_KEY);
}

interface Props {
  buttons: Array<ModalButton>;
  onClose: () => void;
}

function GenentechPTDTrainingModalInfo({buttons, onClose}: Props): JSX.Element {
  return (
    <Modal
      enableRedesign={true}
      title="Notice of Training Environment"
      buttons={buttons}
      onRequestClose={onClose}
      closeable={false}
      closeableOnBackgroundClick={false}
      closeableOnEscapeKey={false}
    >
      <div>
        <p>
          You are currently accessing the TRAINING ENVIRONMENT for PTD Benchling. The training environment
          shall only be used for training purposes. <span className={css(styles.emphasized)}>DO NOT</span>{' '}
          document your work in this environment. <span className={css(styles.emphasized)}>DO NOT</span>{' '}
          upload or capture experiment execution data or information to this environment.
        </p>
        <p>
          The TRAINING ENVIRONMENT is only for training purposes for PTD members. It is not intended for any
          other purpose or user group.
        </p>
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  emphasized: {
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
});

export function GenentechPTDTrainingModal(): JSX.Element {
  return (
    <GenentechPTDTrainingModalInfo
      onClose={() => {
        dismissModal();
      }}
      buttons={[
        {
          text: 'I Agree',
          style: 'default',
          onClick: () => {
            dismissModal();
          },
        },
      ]}
    />
  );
}
